<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            {
              component: 'h3',
              innerText: 'Slajdy'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image']
                  }),
                  new fields.Input({
                    label: 'Link do filmu Vimeo',
                    modelPath: [this, 'form', 'items', i, 'video_url']
                  }),
                  new fields.Video({
                    label: 'Wideo',
                    modelPath: [this, 'form', 'items', i, 'video']
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
